import { useEffect, useState } from "react";
import "./ECGChart.css";

export default function ECGChart() {
  const [points, setPoints] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => {
      setPoints(prev => {
        const nextY =
          60 +
          Math.sin(Date.now() / 120) * 30 +
          (Math.random() - 0.5) * 10;

        const nextX = prev.length ? prev[prev.length - 1].x + 10 : 0;

        const updated = [...prev, { x: nextX, y: nextY }];
        return updated.slice(-60);
      });
    }, 50);

    return () => clearInterval(interval);
  }, []);

  const polylinePoints = points
    .map(p => `${p.x},${p.y}`)
    .join(" ");

  return (
    <div className="ecg-card">
      <div className="ecg-header">
        <h3>ECG</h3>
        <span className="live-dot">LIVE</span>
      </div>

      <svg
        width="100%"
        height="200"
        viewBox="0 0 600 120"
        preserveAspectRatio="none"
        className="ecg-svg"
      >
        <polyline
          fill="none"
          stroke="#22c55e"
          strokeWidth="2"
          points={polylinePoints}
        />
      </svg>
    </div>
  );
}
